import React from 'react'
import Header from '../_layouts/public/Header'
import Footer from '../_layouts/public/Footer'
import bags from './../../assets/img/bags.jpeg';
import WelcomeArea2 from '../_layouts/public/pages/WelcomeArea2';
import { Link } from 'react-router-dom';
import {
  FaOilCan,
  FaCar,
  FaFlask,
  FaBroom,
  FaPaintRoller,
  FaUtensils,
  FaGlassWhiskey,
  FaExclamationTriangle
} from "react-icons/fa";

const Products1 = () => {
    const pg = 'SpillClean';

  return (
    <>
    <Header />
    <WelcomeArea2 pg={pg} />

    <section className="mosh-aboutUs-area py-5">
        <div className="container py-4">
            <div className="row align-items-center">
                <div className="col-12 col-md-6">
                    <div className="mosh-about-us-content">
                        <div className="section-heading mb-4">
                            <h2><span className="green-span">Products - SpillClean</span><br />Browse and shop now!</h2>
                        </div>
                    </div>
                </div>
            </div>    
            
            <div className="row mt-5 pt-4">
                <Link to="/products/spillclean-powder" 
                    className="col-12 col-md-4 text-center mb-5 pb-5 product">

                    <div className="col-12 text-center">
                        <FaBroom className="fa-5x text-success mb-3" />
                        <h3>SpillClean Powder</h3>
                        <Link to="/products/spillclean-powder" className="text-success">Visit product page</Link>
                    </div>
                </Link>

                <Link to="/products/fertilizer-and-water-mixing-machine" 
                    className="col-12 col-md-4 text-center mb-5 pb-5 product">

                    <div className="col-12 text-center">
                        <FaPaintRoller className="fa fa-whatsapp fa-5x text-success mb-3" />
                        <h3>Fertilizer and Water Mixing Machine</h3>
                        <Link to="/products/fertilizer-and-water-mixing-machine" className="text-success">
                            Visit product page</Link>
                    </div>
                </Link>
                
                <Link to="/products/cocopeat-and-coconut-husk-chips" 
                    className="col-12 col-md-4 text-center mb-5 pb-5 product">

                    <div className="col-12 text-center">
                        <FaFlask className="fa fa-envelope fa-5x text-success mb-3" />
                        <h3>Cocopeat and Coconut Husk Chips</h3>
                        <Link to="/products/cocopeat-and-coconut-husk-chips" className="text-success">
                            Visit product page</Link>
                    </div>
                </Link>
                
            </div>

            <div className='text-center'>
                <Link to="/products" class="btn mosh-btn mt-4 ">shop our products</Link> 
            </div>

        </div>
    </section> 

    <Footer />
    </>
  )
}
export default Products1;